import defaultWebGlobal from '#themes/default/web/components/global/global.js';

import cBreadcrumb from '#themes/avast/web/components/breadcrumb/breadcrumb.js';
import cError from '#themes/avast/web/components/error/error.js';
import cFooter from '#themes/avast/web/components/footer/footer.js';
import cModal from '#themes/avast/web/components/modal/modal.js';
import cNotificationBar from '#themes/avast/web/components/notificationBar/notificationBar.js';
import cPageLayout from '#themes/avast/web/layouts/pageLayout/pageLayout.js';
import cPaymentMethods from '#themes/avast/web/components/paymentMethods/paymentMethods.js';
import cPaymentSelection from '#themes/avast/web/components/paymentSelection/paymentSelection.js';
import cSidebar from '#themes/avast/web/components/sidebar/sidebar.js';
import cSvgStorage from '#themes/avast/web/components/svgStorage/svgStorage.js';

import '#themes/avast/web/app.css' with { type: 'css' };

export default {
	middleware: defaultWebGlobal.middleware,
	components: {
		cBreadcrumb,
		cError,
		cFooter,
		cModal,
		cNotificationBar,
		cPageLayout,
		cPaymentMethods,
		cPaymentSelection,
		cSidebar,
		cSvgStorage
	},
	extends: defaultWebGlobal
};
